import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Logo from "@/components/Logo";

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="dark-section relative overflow-hidden border-t border-white/10"
    >
      <div className="max-w-[1380px] mx-auto px-6 lg:px-10 pt-20 pb-10">
        {/* Big CTA strip */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 pb-16 border-b border-white/10">
          <div className="lg:col-span-7">
            <p className="kicker mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-[#00e5ff]" />
              Sentinel Diagnostic
            </p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-[64px] font-bold tracking-tight text-white leading-[1.02]">
              Show us your data.<br />
              We&rsquo;ll show you the blind spots.
            </h2>
          </div>
          <div className="lg:col-span-5 flex lg:items-end lg:justify-end">
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="/get-started?type=diagnostic"
                data-testid="footer-cta-diagnostic"
                className="btn-primary"
              >
                Request diagnostic <ArrowUpRight className="w-4 h-4" />
              </a>
              <a
                href="/get-started?type=workshop"
                data-testid="footer-cta-workshop"
                className="btn-ghost-dark"
              >
                Book workshop
              </a>
            </div>
          </div>
        </div>

        {/* Footer columns */}
        <div className="grid grid-cols-2 lg:grid-cols-12 gap-10 py-14">
          <div className="col-span-2 lg:col-span-5">
            <Logo variant="dark" testId="footer-logo" />
            <p className="mt-6 text-white/60 text-[15px] leading-relaxed max-w-md">
              Sentinel is a deterministic compliance intelligence overlay for
              EU universal banks, mid-tier banks and BaaS operators. It solves
              two problems: <span className="text-white">false-positive
              reduction</span> for AML and fraud alerts, and{" "}
              <span className="text-white">missed risk</span> that hides
              when entity resolution and cross-system context are absent.
            </p>
            <div className="mt-8 flex flex-wrap gap-2">
              {["AMLA-aligned", "EU AI Act Art. 14", "DORA-ready", "GDPR by design"].map((t) => (
                <span
                  key={t}
                  className="font-mono text-[10px] tracking-[0.16em] uppercase text-white/70 border border-white/15 px-2.5 py-1.5"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <p className="font-mono text-[11px] tracking-[0.18em] uppercase text-white/40 mb-4">Product</p>
            <ul className="space-y-3">
              <li><Link to="/product" className="text-white/80 hover:text-white text-[15px]">Overview</Link></li>
              <li><Link to="/product#pipeline" className="text-white/80 hover:text-white text-[15px]">Pipeline</Link></li>
              <li><Link to="/product#entity-resolution" className="text-white/80 hover:text-white text-[15px]">Entity Resolution</Link></li>
              <li><Link to="/product#ffpre" className="text-white/80 hover:text-white text-[15px]">FPRE &amp; FFPRE</Link></li>
            </ul>
          </div>
          <div className="lg:col-span-2">
            <p className="font-mono text-[11px] tracking-[0.18em] uppercase text-white/40 mb-4">Company</p>
            <ul className="space-y-3">
              <li><Link to="/why-lexifide" className="text-white/80 hover:text-white text-[15px]">Why Lexifide</Link></li>
              <li><Link to="/resources" className="text-white/80 hover:text-white text-[15px]">Resources</Link></li>
              <li><Link to="/contact" className="text-white/80 hover:text-white text-[15px]">Contact</Link></li>
            </ul>
          </div>
          <div className="lg:col-span-3">
            <p className="font-mono text-[11px] tracking-[0.18em] uppercase text-white/40 mb-4">Office</p>
            <p className="text-white/80 text-[15px] leading-relaxed">
              Stockholm, Sweden<br />
              EU-resident infrastructure<br />
              AWS Stockholm region
            </p>
          <a
            href="mailto:hello@lexifide.ai"
            data-testid="footer-email"
            className="mt-4 inline-flex items-center gap-2 text-white text-[15px] link-underline"
          >
              hello@lexifide.ai <ArrowUpRight className="w-3.5 h-3.5" />
            </a>
          </div>
        </div>

        <div className="pt-6 flex flex-col md:flex-row gap-4 items-start md:items-center justify-between border-t border-white/10">
          <p className="font-mono text-[11px] text-white/40 tracking-[0.12em]">
            &copy; {new Date().getFullYear()} LEXIFIDE.AI &nbsp;/&nbsp; ALL RIGHTS RESERVED
          </p>
          <p className="font-mono text-[11px] text-white/40 tracking-[0.12em]">
            v1.0 &middot; SENTINEL &middot; ADVISORY-ONLY
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
